import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

function TableTab02({ style, list }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <TableTabWrapper style={{ ...style }}>
        {list.map((item, index) => {
          return (
            <Tab
              key={index}
              style={{
                color: `${
                  location.pathname.includes(item.originLink)
                    ? "#27BEFF"
                    : "#ADB4BA"
                }`,
                borderBottom: `${
                  location.pathname.includes(item.originLink)
                    ? "2px solid #27BEFF"
                    : "2px solid #fff"
                }`,
              }}
              onClick={() => {
                if (item.link === location.pathname) return;
                else navigate(item.link);
              }}
            >
              {item.title}
            </Tab>
          );
        })}
      </TableTabWrapper>
    </>
  );
}

export default TableTab02;

const TableTabWrapper = styled.div.attrs((props) => {})`
  width: 924px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const Tab = styled.div.attrs((props) => {})`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 21px;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px; /* 162.5% */
  cursor: pointer;
`;
